var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgBonanzaWallet = function SvgBonanzaWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 10,
    r: 3,
    fill: "#121212"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.2093V2.79068C0 1.24946 1.24946 0 2.79068 0H12.8371C14.5838 0 15.9999 1.41626 15.9999 3.16281C15.9999 3.47091 15.7499 3.72095 15.4418 3.72095C15.1337 3.72095 14.8837 3.47091 14.8837 3.16281C14.8837 2.03235 13.9675 1.11627 12.8371 1.11627H2.79068C1.86564 1.11627 1.11627 1.86564 1.11627 2.79068C1.11627 3.71572 1.86564 4.46509 2.79068 4.46509H13.2093C14.7505 4.46509 16 5.71455 16 7.25577V13.2093C16 14.7505 14.7505 16 13.2093 16H2.79068C1.24946 16 0 14.7505 0 13.2093ZM13.5812 10.2324C13.5812 9.6162 13.0811 9.11611 12.4649 9.11611C11.8487 9.11611 11.3487 9.6162 11.3487 10.2324C11.3487 10.8486 11.8487 11.3487 12.4649 11.3487C13.0811 11.3487 13.5812 10.8486 13.5812 10.2324ZM12.465 3.34881H3.53482C3.22672 3.34881 2.97668 3.09878 2.97668 2.79068C2.97668 2.48258 3.22672 2.23254 3.53482 2.23254H12.465C12.7731 2.23254 13.0231 2.48258 13.0231 2.79068C13.0231 3.09878 12.7731 3.34881 12.465 3.34881Z",
    fill: "currentColor"
  })));
};
var Memo = /*#__PURE__*/memo(SvgBonanzaWallet);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "_/_/packages/moonlight/lib/assets/icons/bonanza-wallet.20df3bfd2a5126b9dad1039c805c8452.svg";